import AppMailIcon from './AppMailIcon';
import AppAtSignIcon from './AppAtSignIcon';
import AppCellPhoneIcon from './AppCellPhoneIcon';
import AppTelephoneIcon from './AppTelephoneIcon';
import AppUploadIcon from './AppUploadIcon';
import AppMalePersonIcon from './AppMalePersonIcon';
import AppWritingIcon from './AppWritingIcon';
import AppKeyIcon from './AppKeyIcon';
import AppStudentCapIcon from './AppStudentCapIcon';
import AppChatBubbleIcon from './AppChatBubbleIcon';
import AppHouseIcon from './AppHouseIcon';
import AppTelegramIcon from './AppTelegramIcon';
import AppInstagramIcon from './AppInstagramIcon';
import AppLinkedinIcon from './AppLinkedinIcon';
import AppTwitterIcon from './AppTwitterIcon';
import AppFacebookIcon from './AppFacebookIcon';
import AppSignOutIcon from './AppSignOutIcon';
import AppExchangeIcon from './AppExchangeIcon';
import AppMultiplePersonsIcon from './AppMultiplePersonsIcon';
import AppInfoIcon from './AppInfoIcon';
import AppStackPapersIcon from './AppStackPapersIcon';

export default function (Vue) {
  Vue.component('app-mail-icon', AppMailIcon);
  Vue.component('app-at-sign-icon', AppAtSignIcon);
  Vue.component('app-cell-phone-icon', AppCellPhoneIcon);
  Vue.component('app-telephone-icon', AppTelephoneIcon);
  Vue.component('app-upload-icon', AppUploadIcon);
  Vue.component('app-male-person-icon', AppMalePersonIcon);
  Vue.component('app-multiple-persons-icon', AppMultiplePersonsIcon);
  Vue.component('app-writing-icon', AppWritingIcon);
  Vue.component('app-key-icon', AppKeyIcon);
  Vue.component('app-student-cap-icon', AppStudentCapIcon);
  Vue.component('app-chat-bubble-icon', AppChatBubbleIcon);
  Vue.component('app-house-icon', AppHouseIcon);
  Vue.component('app-sing-out-icon', AppSignOutIcon);
  Vue.component('app-telegram-icon', AppTelegramIcon);
  Vue.component('app-instagram-icon', AppInstagramIcon);
  Vue.component('app-linkedin-icon', AppLinkedinIcon);
  Vue.component('app-twitter-icon', AppTwitterIcon);
  Vue.component('app-facebook-icon', AppFacebookIcon);
  Vue.component('app-exchange-icon', AppExchangeIcon);
  Vue.component('app-info-icon', AppInfoIcon);
  Vue.component('app-stack-papers-icon', AppStackPapersIcon);
}
